module.exports = __webpack_public_path__ + "static/media/front.096cca00.jpg";